// A registration's history as a timeline: a heading per day, then each step with its time, what happened, its detail,
// who, and (back office) the emails it sent. The code shows only when the registration has more than one.
// Used by the History dialog on the agent screen and inline on the back office's record page (Task B3).
import React from "react";

// Times are Eastern for everyone, so the agent and the events team see the same time on the phone together.
const TZ = { timeZone: "America/Detroit" };
export default function History({ events, inline }) {
  if (!events.length) return <p>Nothing has happened yet.</p>;
  const several = new Set(events.map(e => e.code).filter(Boolean)).size > 1;
  const dayOf = (d) => new Date(d).toLocaleDateString("en-US", { ...TZ, weekday: "short", month: "short", day: "numeric" });
  const days = [];
  for (const e of events) { const d = dayOf(e.at); if (days.at(-1)?.day !== d) days.push({ day: d, events: [] }); days.at(-1).events.push(e); }
  // Focusable so the keyboard can scroll a long history.
  return (
    <div className={`dlg-history ${inline ? "inline" : ""}`} {...(!inline && { tabIndex: 0, role: "region", "aria-label": "History, newest first" })}>
      {days.map(({ day, events: list }) => (
        <section key={day}>
          <h3 className="h-day">{day}</h3>
          <ol>{list.map((e, i) => (
          <li key={i} className="h-row">
            <div className="h-time">{new Date(e.at).toLocaleTimeString("en-US", { ...TZ, hour: "numeric", minute: "2-digit", timeZoneName: "short" })}</div>
            <div>
              <div className="h-what">{e.text}{several && e.code && <span className="mono h-code">{e.code}</span>}</div>
              {e.detail && <div className="h-detail">{e.detail}</div>}
              {(e.by || e.to) && <div className="h-who">{e.by ? `by ${e.by}` : `to ${e.to}`}</div>}
              {e.emails?.map((m, j) => <div key={j} className={`h-email ${m.status === "failed" ? "failed" : ""}`}>
                <div>{m.subject}</div><div className="h-who">Email to {m.to} · {m.status}</div></div>)}
            </div>
          </li>))}</ol>
        </section>
      ))}
    </div>
  );
}

